import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { MessagePlugin } from 'tdesign-react';

import { SenderType } from '@/const/mission';
import { IMission, PropsIData } from '@/interface';
import { CgiErrorCode } from '@/services/cgi';
import { fetchPropsDetail, fetchPropsList } from '@/services/props';

export interface PropsState {
  loading: boolean;
  propsInfo: PropsIData;
  prompt: boolean;
  props: IMission[];
  listLoading: boolean;
}

const initialState: PropsState = {
  loading: false,
  props: [],
  propsInfo: {
    id: '',
    name: '',
    bgImage: {},
    assets: [],
    isNecessary: false,
    assetsEvent: [
      {
        type: 1,
        message: {
          text: {
            text: '',
            showType: 0,
          },
          type: 1,
          sender: {
            type: SenderType.SYSTEM,
            senderId: '',
          },
        },
      },
    ],
    relatedMessages: [
      {
        type: 1,
        message: {
          text: {
            text: '',
            showType: 0,
          },
          type: 1,
          sender: {
            type: SenderType.BOT,
            senderId: '',
          },
        },
      },
    ],
  },
  prompt: false,
  listLoading: false,
};
export const getPropsDetail = createAsyncThunk('props/fetchPropsDetail', fetchPropsDetail);

export const getProps = createAsyncThunk(
  'prop/list',
  fetchPropsList,
);

export const props = createSlice({
  name: 'mission',
  initialState,
  reducers: {
    initPropsInfo(state) {
      state.propsInfo = initialState.propsInfo;
    },

    setPrompt(state, { payload }) {
      state.prompt = payload;
    },
    setLoading(state, { payload }) {
      state.loading = payload;
    },
    updatePropsInfo: (state, { payload }) => {
      state.propsInfo = { ...payload };
    },
    clearProps() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPropsDetail.fulfilled, (state, { payload }) => {
      const { code, data, message } = payload;
      if (code === CgiErrorCode.NO_ERROR) {
        return {
          ...state,
          loading: false,
          propsInfo: {
            ...data,
          },
        };
      }
      MessagePlugin.error(message);
    });
    builder.addCase(getProps.fulfilled, (state, { payload }) => {
      if (!payload) {
        return initialState;
      }
      return {
        ...state,
        props: payload.list,
      };
    });
  },
});

export const {
  setPrompt,
  initPropsInfo,
  updatePropsInfo,
  setLoading,
  clearProps,
} = props.actions;

export default props.reducer;
